<template>
  <tr class="DiffRow">
    <td class="key">
      {{ diffKey }}
    </td>
    <td class="valueOriginal">
      {{ diff.valueOriginal }}
    </td>
    <td class="value">
      <template v-if="diff.diffs">
        <DiffCell
          v-for="({ theme, type, value }, index) in diff.diffs"
          :key="index"
          :theme="theme"
          :type="type"
          :value="value" />
      </template>
      <span v-else class="valuePlain">
        {{ diff.value }}
      </span>
      <div class="diffActions">
        <Btn class="xs ib inv noBorder success" @click="$emit('accept', diffKey)">
          <Icon name="check" />
        </Btn>
        <Btn class="xs ib inv noBorder danger" @click="$emit('reject', diffKey)">
          <Icon name="cross" />
        </Btn>
      </div>
    </td>
  </tr>
</template>

<script>
import DiffCell from './DiffCell'

export default {
  components: {
    DiffCell,
  },
  props: {
    diffKey: { type: String, require: true },
    diff: { type: Object, required: true },
  },
}
</script>

<style lang="scss">
.DiffRow {
  td {
    padding: 0.25rem $uh;
  }

  > .value {
    align-items: center;
    display: flex;
    flex-direction: row;

    > .valuePlain {
      color: $text-color-light;
    }

    > .diffActions {
      @include trans(0.3s, 'opacity');
      opacity: 0;
    }
  }

  &:hover {
    > .value > .diffActions {
      opacity: 1;
    }
  }
}
</style>
